// GA4 + Google Ads tag + OpenAI pixel for luxesupply.co (GA4 2026-10-22; Ads tag + OpenAI pixel 2026-10-23, Dan / Claude).
// Same GA4 property as portal.luxesupply.co (G-GWV7X0D9R6). Google Ads tag AW-11158472528 adds visitors to the portal's retargeting audiences; no conversion events here (applications convert on the portal).
// Consent Mode v2: everything denied by default and upgraded from Shopify's customer-privacy API (analytics / marketing), matching the portal: with marketing consent, ad storage, ad user data and ad personalization are granted.
// OpenAI (ChatGPT) Ads pixel FnGVCTdo5WaJQG7RpATavV: page view only, loaded only with marketing consent and only for non-European time zones (same rule as the portal, PR #238).
// Loaded from layout/theme.liquid: {{ 'ga4-luxe-supply.js' | asset_url | script_tag }}
// To undo: delete that line (and this file).
(function () {
var ID = 'G-GWV7X0D9R6';
var ADS = 'AW-11158472528';
var OPENAI_PIXEL = 'FnGVCTdo5WaJQG7RpATavV';
window.dataLayer = window.dataLayer || [];
function gtag() { window.dataLayer.push(arguments); }
gtag('consent', 'default', {
analytics_storage: 'denied',
ad_storage: 'denied',
ad_user_data: 'denied',
ad_personalization: 'denied',
wait_for_update: 500
});
gtag('set', 'url_passthrough', true);
gtag('js', new Date());
gtag('config', ID, { allow_google_signals: false });
gtag('config', ADS);
var s = document.createElement('script');
s.async = true;
s.src = 'https://www.googletagmanager.com/gtag/js?id=' + ID;
document.head.appendChild(s);
var pixelLoaded = false;
function loadOpenAiPixel() {
if (pixelLoaded) return;
var tz = '';
try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) {}
if (!tz || /^Europe\//.test(tz) || /^Atlantic\/(Reykjavik|Canary|Madeira|Azores|Faroe)$/.test(tz)) return;
pixelLoaded = true;
(function (w, d, t, u) { if (w.oaiq) return; var q = function () { q.q.push(arguments); }; q.q = []; w.oaiq = q; var js = d.createElement(t); js.async = true; js.src = u; var f = d.getElementsByTagName(t)[0]; f.parentNode.insertBefore(js, f); })(window, document, 'script', 'https://bzrcdn.openai.com/sdk/oaiq.min.js');
window.oaiq('init', { pixelId: OPENAI_PIXEL });
}
function applyConsent() {
try {
var cp = window.Shopify && window.Shopify.customerPrivacy;
if (!cp) return;
var analytics = cp.analyticsProcessingAllowed ? cp.analyticsProcessingAllowed() : false;
var marketing = cp.marketingAllowed ? cp.marketingAllowed() : false;
gtag('consent', 'update', {
analytics_storage: analytics ? 'granted' : 'denied',
ad_storage: marketing ? 'granted' : 'denied',
ad_user_data: marketing ? 'granted' : 'denied',
ad_personalization: marketing ? 'granted' : 'denied'
});
if (marketing) loadOpenAiPixel();
} catch (e) {}
}
document.addEventListener('visitorConsentCollected', applyConsent);
if (window.Shopify && window.Shopify.loadFeatures) {
window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
if (!error) applyConsent();
});
}
})();
